"use client";
import LinkIcon from "@/assets/vectors/Link";
import dictionary from "@/utils/dictionary";
import { useState } from "react";
import styles from "./brief.module.scss";

export default function BriefShare() {
    const [message, setMessage] = useState("");
    const copy = dictionary.brief;
    return (
        <div className={styles.share}>
            <button
                type="button"
                onClick={async () => {
                    try {
                        await navigator.clipboard.writeText(window.location.href.split("#")[0]);
                        setMessage(copy.copied);
                    } catch {
                        setMessage(copy.copy_failed);
                    }
                }}
            >
                {copy.share} <LinkIcon className={styles.icon} aria-hidden="true" width={12} />
            </button>
            <span role="status">{message}</span>
        </div>
    );
}
